import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { StockTransferService } from '../../../../services/stocktransferservice';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { UserService } from '../../../../services/user';
import { ItemsService } from '../../../../services/items.service';

@Component({
  selector: 'app-stocktransfershistroy',
  templateUrl: './stocktransfershistroy.component.html',
  styleUrl: './stocktransfershistroy.component.scss'
})
export class StocktransfershistroyComponent implements OnInit {
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  superAdmin!: boolean;
  contentReady = true;
  noData = false;
  isMobile = false;

  displayedColumns: string[] = [
    'id',
    'user',
    'from',
    'to',
    'items',
    'notes',
    'created_at'
  ];

  accountType!: string;
  dataSource = new MatTableDataSource<any>([]);
  total = 0;
  pageSize = 10;
  pageIndex = 0;
  warehouseid!: any;
  allWareHouses: any
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private _userService: UserService,
    private _ItemsService: ItemsService,
    private stockTransferService: StockTransferService,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.superAdmin = this.accountType == "10";
        this.isAdmin = this.accountType == "1";
        this.isSubAdmin = this.accountType == "6";
        this.superAdmin
          ? this.loadData(1)
          : this.loadData(1, localStorage.getItem("posId") ?? undefined);

        if (this.isAdmin || this.superAdmin)
          this.getWarehouses()
      },
      error: (error) => console.error(error),
    });


  }
  applyWareHouse(warehouseId: any) {
    this.resetPagination();
    this.warehouseid = warehouseId;
    this.loadData(1, warehouseId);
  }
  resetPagination() {
    if (this.paginator) this.paginator.firstPage();
    this.pageIndex = 1;
  }
  getWarehouses() {

    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res.warehouse
      },
      error: (err) => {

      },
    });
  }
  loadData(page: number, warehouseId?: string | null) {
    this.contentReady = true;

    this.stockTransferService.getHistory(page, this.pageSize, warehouseId).subscribe({
      next: (res) => {
        this.dataSource.data = res.data;
        this.total = res.total;
        this.noData = res.data.length === 0;
        this.contentReady = false;
      },
      error: () => {
        this.noData = true;
        this.contentReady = false;
      }
    });
  }

  onPaginateChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.loadData(event.pageIndex + 1);
  }

  formatDate(date: string): string {
    const d = new Date(date);
    return d.toLocaleDateString('en-GB');
  }
}
